<!--
  - 代码运行终端栏
-->

<template>
	<div class="widget_terminal" v-show="show" :style="{height: height, bottom: bottom, width: width}">
		<div id="terminal_content"></div>
	</div>
</template>


<script>
	import 'xterm/css/xterm.css'
	// import '@/assets/css/icon/build.css';
	import {Terminal} from 'xterm';
	import {FitAddon} from 'xterm-addon-fit';

	export default {
		name: 'widget_terminal',
		data(){
			return {
				xterm: null,
			}
		},
		props: {
			height: {
				type: String,
				default: '250px',
			},
			bottom: {
				type: String,
				default: '30px',
			},
			width: {
				type: String,
				default: window.innerWidth + "px",
			},
			show: {
				type: Boolean,
				default: true,
			}
		},
		components: {},
		methods: {
			terminalClose(){
				this.$emit('terminalClose');
			},
			terminalClear(){
				this.xterm.clear();
				//say hello
				this.sayNormal("* Welcome bytelang console. Hope you have a good coding time");
			},
			resizeTerminal(){
				let xterm = this.xterm;
				if(xterm !== null){
					let renderer = xterm._core._renderService;
					window.abc = renderer;
					if('dimensions' in renderer){
						let cols = parseInt(parseInt(this.width) / renderer.dimensions.actualCellWidth);
						let rows = parseInt(parseInt($('#terminal_content').css('height')) / renderer.dimensions.actualCellHeight);
						xterm.resize(cols, rows);
						this.$parent.$emit('terminal-resize', {cols, rows});
					}
				}
			},
			write(str){
				this.xterm.write(str);
			},
			sayNormal(str){
				this.xterm.write(str + "\r\n");
			},
			sayHigh(str){
				this.xterm.write("\u001b[34m" + str + "\u001b[39m");
			},
			sayError(str){
				this.xterm.write("\u001b[31m" + str + "\u001b[39m");
			},
			sayExit(str){
				this.xterm.write("\u001b[31m" + str + "\u001b[39m" + "\r\n");
			},
			getColsRows(){
				return {
					cols: this.xterm.cols,
					rows: this.xterm.rows,
				}
			}
		},
		mounted(){
			this.resizeTerminal();
		},
		watch: {
			'width': function(newValue, oldValue){
				this.resizeTerminal();
			}
		},
		created(){
			let that = this;
			this.$nextTick(()=>{
				let xterm = new Terminal({
					cols: 120,
					rows: 10,
					tabStopWidth: 4,
					fontSize: 13,
					fontWeight: 100,
				});

				let fitAddon = new FitAddon();

				xterm.loadAddon(fitAddon);
				xterm.open(document.getElementById('terminal_content'));
				fitAddon.fit();

				xterm.onData(function(data){
					that.$parent.$emit('terminal-update', data);
				});
				that.xterm = xterm;
				that.resizeTerminal();

				$(window).resize(function(){
					that.resizeTerminal();
				});

				//say hello
				that.sayNormal("* Welcome bytelang console. Hope you have a good coding time");
			})
		}
	}
</script>

<style scoped lang="less">
	@import "../../../../src/theme/default";
	
	@terminal_background: #000;
	@toolkit_background: #252526;
	.widget_terminal {
		position: absolute;
		flex-direction: column;
		width: 100%;
		height: 100%;
		background: @terminal_background;
		color: white;
		z-index: 9;
		
		#terminal_content {
			position: absolute;
			width: 100%;
			top: 0;
			bottom: 0;
		}
		
		.toolkit {
			background: @toolkit_background;
			flex: 1;
			display: flex;
			justify-content: flex-end;
			padding: 5px 30px;
			border-bottom: 1px solid #666;
			height: @header_height;
			
			button {
				margin-left: 20px;
				width: 80px;
			}
		}
	}
</style>

